import { isTablet } from 'react-device-detect';
import { isNotStandaloneMobilePWA } from '../../../../../utils/mobileSupported';

import LeftSideDefault from './LeftSideDefault';
import LeftSideSmallScreen from './LeftSideSmallScreen';
const BottomBarLeftSide = isNotStandaloneMobilePWA && !isTablet ? LeftSideSmallScreen : LeftSideDefault;

export default BottomBarLeftSide;

